//==========import components===============
import { Link } from 'react-router-dom';
import { AiFillRightCircle } from 'react-icons/ai';

const Button = ({ url, title }) => {
  return (
    <section>
      <div className='commonBtn flex items-center'>
        <Link
          to={url}
          type='button'
          className='group hover:text-white text-eventLightYellow font-medium sm:text-base text-sm hover:bg-eventLightYellow bg-transparent rounded-full pr-2 pl-5 py-1 sm:py-1.5 contactBtn flex items-center capitalize border-2 border-eventLightYellow hover:transition-all transition duration-150 ease-in-out'>
          {title}
          <AiFillRightCircle
            className='ml-5 text-eventYellow group-hover:text-white group-hover:translate-x-1 group-hover:transition-all group-hover:ease-in'
            size={25}
          />
        </Link>
      </div>
    </section>
  );
};

export default Button;
